<script setup>
import TripFinderRefine from './TripFinderRefine.vue'

const props = defineProps({
  dropdownStyle: {
    type: Object,
    default: () => ({}),
  },
  open: {
    type: Boolean,
    default: false,
  },
  mode: {
    type: String,
    default: 'build',
  },
  scope: {
    type: String,
    default: 'local',
  }
})

const emit = defineEmits(['update:open', 'search'])

</script>

<template>
  <div class="tripfinder-desktop-refine-panel">
    <transition
      enter-active-class="transition-opacity duration-300 ease-out"
      leave-active-class="transition-opacity duration-200 ease-in"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="open"
        class="tripfinder-desktop-refine-panel__backdrop fixed inset-0 bg-[#2F3033]/30 backdrop-blur-sm z-[65]"
        @click="emit('update:open', false)"
      ></div>
    </transition>

    <transition
      name="accordion"
      enter-active-class="transition-all duration-300 ease-out"
      leave-active-class="transition-all duration-200 ease-in"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="open"
        class="tripfinder-desktop-refine-panel__dropdown absolute left-1/2 top-0 z-[70] -translate-x-1/2 transform"
        :style="dropdownStyle"
      >
        <TripFinderRefine
          :show="false"
          :open="true"
          :mode="mode"
          :scope="scope"
          @update:open="emit('update:open', $event)"
          @search="emit('search')"
        />
      </div>
    </transition>
  </div>
</template>
